__turbopack_context__.v({
  "accordionContent": "mobile-locale-switcher-module__e8fB6a__accordionContent",
  "accordionHeader": "mobile-locale-switcher-module__e8fB6a__accordionHeader",
  "accordionItem": "mobile-locale-switcher-module__e8fB6a__accordionItem",
  "accordionRoot": "mobile-locale-switcher-module__e8fB6a__accordionRoot",
  "accordionTrigger": "mobile-locale-switcher-module__e8fB6a__accordionTrigger",
  "accordionTriggerContainer": "mobile-locale-switcher-module__e8fB6a__accordionTriggerContainer",
  "caretIcon": "mobile-locale-switcher-module__e8fB6a__caretIcon",
  "currentLocale": "mobile-locale-switcher-module__e8fB6a__currentLocale",
  "currentLocaleCode": "mobile-locale-switcher-module__e8fB6a__currentLocaleCode",
  "currentLocaleLabel": "mobile-locale-switcher-module__e8fB6a__currentLocaleLabel",
  "edit": "mobile-locale-switcher-module__e8fB6a__edit",
  "localeOption": "mobile-locale-switcher-module__e8fB6a__localeOption",
  "localeOptionActive": "mobile-locale-switcher-module__e8fB6a__localeOptionActive",
  "localeOptions": "mobile-locale-switcher-module__e8fB6a__localeOptions",
  "optionCode": "mobile-locale-switcher-module__e8fB6a__optionCode",
  "optionLabel": "mobile-locale-switcher-module__e8fB6a__optionLabel",
  "triggerContent": "mobile-locale-switcher-module__e8fB6a__triggerContent",
  "triggerLabel": "mobile-locale-switcher-module__e8fB6a__triggerLabel",
});
